/**
 * 按照指定顺序讲产品分类排序
 * @param configOrder
 * @param productTypes
 * return T[]
 */
export function getOrderedProductWithType<T>(
  configOrder: string[],
  data: { [productType: string]: T[] }
): {
  productList: T[];
  productType: string;
}[] {
  const prodTypeOrderList = [].concat(configOrder);

  const prodTypes = Object.keys(data);
  prodTypes.forEach((prodType) => {
    if (!configOrder.includes(prodType)) {
      prodTypeOrderList.push(prodType);
    }
  });

  const response = prodTypeOrderList.reduce((res, item) => {
    res.push({
      productType: item,
      productList: data[item],
    });
    return res;
  }, []);
  return response;
}
